import React, { Fragment, useEffect, useState } from 'react';
import MaskedInput from 'react-text-mask';

// Utils

import { phoneNumberTools } from '@utils/tools/phoneNumberTools';
import validators, { validateValueByValidationType } from '@utils/validators/validators';
import { ConditionalRendering } from '@components/common/conditional-rendering';


// Constants

import { VALIDATION_TYPES } from '@constants/inputs/validationTypes';
import { MASKED_PHONE_NUMBER_LENGTH, PHONE_NUMBER_MASK } from '@constants/members/members.constants';

const PhoneNumberInput = props => {

    const {
        inputData: {
            id,
            isInputRequired,
            helperClasses,
            name,
            placeholder,
            type,
            value,
            validationType,
            mask = false
        },
        inputActions: {
            handleFieldChange,
            tracker
        },
        label: {
            text,
            labelClasses,
            ariaLabel,
        },
        labelIcon = {}
    } = props;

    const [ currentValue, updateCurrentValue ] = useState(phoneNumberTools.getAdjustedPhoneNumber(value));

    useEffect(() => {
        const newValue = phoneNumberTools.getAdjustedPhoneNumber(value);
        updateCurrentValue(newValue ? newValue : '');
    }, [value]);

    const sendTrackedValues = nextValue => {
        if(typeof tracker === 'function') {
            const value = phoneNumberTools.cleanedUpPhone(nextValue);

            if(value.length > 10) return null;

            const valid = validateValueByValidationType(value, validationType);

            tracker({ value, valid });
        }

        return null;
    };

    const handlePhoneChange = e => {
        const { value: nextPhoneNumberValue } = e.target;

        sendTrackedValues(nextPhoneNumberValue);

        const grew = nextPhoneNumberValue.length > currentValue.length;
        const lastIsNaN = isNaN(+nextPhoneNumberValue.slice(-1));
        const tooLong = nextPhoneNumberValue.length > MASKED_PHONE_NUMBER_LENGTH;

        if ((grew && lastIsNaN) || tooLong) {
            return null;
        }

        const phoneNumberToSave = phoneNumberTools.autoFillPhone(nextPhoneNumberValue, currentValue);

        updateCurrentValue(phoneNumberToSave);
    };

    const handlePhoneBlur = () => {
        const isPhoneNumberValid =
            validators
                .find(validator => validator.validatorType === VALIDATION_TYPES[validationType])
                .verifier({ value: currentValue });

        if (mask) {
            handleFieldChange(phoneNumberTools.cleanedUpPhone(currentValue));
        } else {
            updateCurrentValue(isPhoneNumberValid ? currentValue : '');
            handleFieldChange(isPhoneNumberValid ? phoneNumberTools.cleanedUpPhone(currentValue) : null);
        }
    };

    return (
        <Fragment>
            <div className={`grid-row gi-component gi-${type} ${helperClasses && helperClasses.join(' ')}`}>
                <label
                    htmlFor={id}
                    className={`tablet:grid-col-4 gi-${type}__label ${labelClasses && labelClasses.join(' ')} iconed-${!!labelIcon.icon} required-${isInputRequired}`}
                    aria-label={ariaLabel}
                >
                    { text }
                    { labelIcon.icon ? labelIcon.icon : null }
                </label>
                <ConditionalRendering isTrue={mask}>
                    <MaskedInput
                        id={id}
                        className={`tablet:grid-col-6 gi-${type}__input`}
                        data-testid={id}
                        name={name}
                        autoComplete="new-password"
                        type="text"
                        value={currentValue || ''}
                        aria-required={isInputRequired}
                        placeholder={placeholder}
                        onChange={handlePhoneChange}
                        onBlur={handlePhoneBlur}
                        mask={PHONE_NUMBER_MASK}
                        onKeyDown={(e) => {
                            const input = e.target;
                            const fullSelection = input.selectionStart === 0 && input.selectionEnd === input.value.length;
                        
                            if (fullSelection && (e.key === 'Backspace' || e.key === 'Delete')) {
                                e.preventDefault();
                                updateCurrentValue('');
                            }
                        }}
                    />
                </ConditionalRendering>
                <ConditionalRendering isTrue={!mask}>
                    <input
                        id={id}
                        className={`tablet:grid-col-6 gi-${type}__input`}
                        data-testid={id}
                        name={name}
                        autoComplete="new-password"
                        type="text"
                        value={currentValue || ''}
                        aria-required={isInputRequired}
                        placeholder={placeholder}
                        onChange={handlePhoneChange}
                        onBlur={handlePhoneBlur}
                    />
                </ConditionalRendering>
            </div>
        </Fragment>
    );
};

export default PhoneNumberInput;

